import { createStackNavigator } from "@react-navigation/stack";
import Login from "../Login/Login";
import { AuthParams } from "./ParamsList/AuthParams";
import React from 'react';
import { observer } from "mobx-react-lite";

const Stack = createStackNavigator<AuthParams>()

const AuthStack = () => {
    return (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
            <Stack.Screen name="Login" component={Login} />
        </Stack.Navigator>
    )
}

export default observer(AuthStack)